module.exports = __webpack_public_path__ + "static/img/no-img.e4188149.png";